



















import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { ISortParameters } from "@/interfaces";
import { AppsMonitorHeader } from "@/components/apps";
import { AppsService, AccountService } from "../services";
import { knownAppsList  } from "@/config";
import axios from "axios";

@Component({
  components: {
    AppsMonitorHeader,
  },
  computed: {
    ...mapGetters("network", ["height", "allApps", "topApps","knownApps"]),
  },
})
export default class AppsMonitor extends Vue {
  private activeTab = "top";
  private height: number;

    public async created() {
      await this.setApps();
    }

    private async setApps() {
      let knownApps;
      try {
        knownApps = (await axios.get(knownAppsList)).data;
      } catch (error) {
        knownApps = {};
      } finally {
        this.$store.dispatch("network/setKnownApps", this.shuffle(knownApps));
      }
    }

    private shuffle(a) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
    }
    return a;
  }
}
